import { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { RouteComponentProps, withRouter } from "react-router";
import styled from "styled-components";
import { Comments } from "../../data/Comment";
import RandomUtils from "../../utils/RandomUtils";

const SectionContainer = styled.div`
  padding: 4rem 0;
  background: #f8f9fa;
`;

const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: 3rem;
  font-weight: bold;
`;

const CommentCard = styled.div`
  background: white;
  border-radius: 15px;
  padding: 2rem;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const CommentText = styled.p`
  font-style: italic;
  margin-bottom: 1.5rem;
  flex-grow: 1;
`;

const CommentAuthor = styled.div`
  display: flex;
  align-items: center;
`;

const Avatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #007bff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 1rem;
`;

const AuthorName = styled.div`
  font-weight: bold;
`;

const ButtonContainer = styled.div`
    text-align: center;
    margin-top: .75rem;
`;

function CommentsView(props: RouteComponentProps) {
    const [comments, _] = useState(RandomUtils.getNumbersArray(0, Comments.length, 3).map(id => Comments[id]));

    return (
        <SectionContainer>
            <div className="container">
                <SectionTitle>Opinie naszych klientów</SectionTitle>
                <Row>
                    {comments.map((comment, i) => (
                        <Col md={4} key={i}>
                            <CommentCard>
                                <CommentText>"{comment.text}"</CommentText>
                                <CommentAuthor>
                                    <Avatar>{comment.author.charAt(0)}</Avatar>
                                    <AuthorName>{comment.author}</AuthorName>
                                </CommentAuthor>
                            </CommentCard>
                        </Col>
                    ))}
                </Row>
                <ButtonContainer>
                    <Button variant="outline-primary" onClick={() => props.history.replace("/gabinet")}>
                        Zobacz więcej opinii
                    </Button>
                </ButtonContainer>
            </div>
        </SectionContainer>
    );
}

export default withRouter(CommentsView);
